export const ARCHIVE_SERVER_PATH = 'https://archive-server-dev.tattle.co.in';
export const TOKEN = '138d34c0-6a5f-11ea-a464-2d8017a18916';
export const USER_ID_TEXT_EXTRACT = 159;
export const TOKEN_TEXT_EXTRACT = '26bc3f50-6a5f-11ea-a464-2d8017a18916';
